import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { LucideAngularModule, Map } from 'lucide-angular';
import { environment } from 'src/environments/environment';
import { TripForSelection } from './select-trip-modal.models';

@Component({
  selector: 'app-trip-selection-card',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    ButtonModule,
    DatePipe,
    LucideAngularModule,
  ],
  templateUrl: './trip-selection-card.component.html',
})
export class TripSelectionCardComponent {
  @Input({ required: true }) trip!: TripForSelection;
  @Output() selectTrip = new EventEmitter<TripForSelection>();
  @Output() finalizeTrip = new EventEmitter<TripForSelection>();

  // Lucide icons
  mapIcon = Map;

  // Track if image has failed to load
  hasValidImage = signal(true);

  get isContributed(): boolean {
    return this.trip.contributionCount > 0;
  }

  get isDraft(): boolean {
    return this.trip.isDraft || !this.trip.hasImpact;
  }

  getImageUrl(path?: string): string {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    return `${environment.apiUrl}${path}`;
  }

  onImageError(): void {
    this.hasValidImage.set(false);
  }

  formatCO2(kg: number): string {
    if (kg >= 1000) {
      return `${(kg / 1000).toFixed(1)} t CO₂`;
    }
    return `${Math.round(kg)} kg CO₂`;
  }
}
